"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RememberSocialStep = void 0;
const react_1 = __importDefault(require("react"));
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const styleClass = (0, css_manager_1.registerClass)((t, sc) => `
	text-align: center;
	
	.${sc('main-text')} {
		margin-bottom: ${t.font.baseSize}px;
	}
	`);
const sc = (0, css_manager_1.currySC)(styleClass);
const RememberSocialStep = ({ t, proceed, socialType, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null, t `remember switch to social title`),
    react_1.default.createElement("section", { className: styleClass },
        react_1.default.createElement("div", { className: sc('main-text'), dangerouslySetInnerHTML: {
                __html: t `remember social account html`,
            } }),
        react_1.default.createElement("div", { className: sc('main-text') },
            t `social login type associated`,
            ":",
            socialType),
        react_1.default.createElement(Button_1.Button, { label: t `proceed`, onClick: () => proceed() }))));
exports.RememberSocialStep = RememberSocialStep;
//# sourceMappingURL=RememberSocialStep.js.map